import React, { useMemo } from 'react'
import TextField from '@material-ui/core/TextField'
import { ErrorMessage } from 'components/Shared/ErrorMessage'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import { ReactComponent as DropdownIcon } from 'assets/icons/dropdown.svg'
import { PrimaryChip } from '../PrimaryChip'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { useTranslation } from 'react-i18next'
import { useField } from 'formik'
import { useValidationSchema } from 'context/validationSchema'
import { isFieldRequired } from 'components/Shared/FormikForm'

const useStyles = makeStyles({
  select: {
    width: '310px'
  }
})

function defaultOptionLabel (option) {
  return option.name
}

function defaultOptionValue (option) {
  return option.id
}

export default function MultiselectField ({
  options,
  getOptionLabel = defaultOptionLabel,
  getOptionValue = defaultOptionValue,
  fieldName,
  onChange,
  label,
  required,
}) {
  const [, meta, helpers] = useField(fieldName)
  const { error, touched, value } = meta
  const { schema } = useValidationSchema()
  const { setValue } = helpers
  const { t } = useTranslation()

  const selectedOptions = options.filter(opt => value?.includes(getOptionValue(opt))) || null
  const isRequired = useMemo(() => isFieldRequired(schema, fieldName), [schema, fieldName])
  const styles = useStyles()

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: getOptionLabel
  })

  return <Autocomplete
    options={options}
    className={styles.select}
    getOptionLabel={getOptionLabel}
    filterOptions={filterOptions}
    filterSelectedOptions
    multiple
    value={selectedOptions}
    noOptionsText={t('form.select.noOptionsText')}
    popupIcon={<DropdownIcon/>}
    onChange={(_, newValues) => {
      setValue(newValues.map(getOptionValue))
      onChange && onChange(newValues)
    }}
    renderTags={(values, getTagProps) =>
      values.map((option, index) => (
        <PrimaryChip
          label={getOptionLabel(option)}
          {...getTagProps({ index })} />
      ))
    }
    required={required === undefined ? isRequired : required}
    renderInput={(params) => (
      <TextField
        {...params}
        error={!!error && touched}
        variant="filled"
        label={t(label)}
        helperText={<ErrorMessage name={fieldName}/>}
        placeholder={t('form.select.title')}
        InputProps={{
          ...params.InputProps,
          disableUnderline: true
        }}
      />
    )}
  />
}
